export enum NotificationType {
  INVOICE = 'Invoice',
  CASE = 'Case',
  CASE_CREATED = 'Case Created',
  /** A Case (`/case-management`) update from the EE-421 pipeline; `path` opens the case. */
  CASE_ACTIVITY = 'Case Update',
  INTAKE_CASE = 'Intake Case Submitted',
  INTAKE_CASE_DELETED = 'Intake Case Deleted',
  INTAKE_CASE_PROCESSED = 'Intake Case Processed',
  MESSAGE = 'Message Received',
  DIRECT_MESSAGE = 'Direct Message Received',
  ATTORNEY_ADD_REQUEST = 'New Client Request',
  ATTORNEY_ADD_REQUEST_CONFIRMED = 'Attorney Request Confirmed',
  CLIENT_ADDED = 'Client Added',
  BULK_CASE_FILES = 'Bulk Case Files',
  BULK_INVOICES = 'Bulk Invoices',
  REPORT_EXPORT = 'Report Export',
  /** Filing Desk bulk send finished (EE-446). `path` is the Drafts queue or Filing history. */
  EFILING_BULK_SUBMIT = 'E-Filing Bulk Submit',
  /** A case bulk import finished (WB-15): one per import, never one per case. `path` is the cases list. */
  CASE_IMPORT = 'Case Import',
  /** Message transcript PDF export finished (EE-480). `path` is the presigned download; absent when it failed. */
  MESSAGE_TRANSCRIPTS = 'Message Transcripts'
}
